import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import UseJwt from '../../core/jwt/jwtService'
import UseJwtCC from '../../core/jwt/cc/jwtServiceCreditCard'

const olaService = new UseJwt({})
const ccService = new UseJwtCC({})


export const getOfferOlaCC = createAsyncThunk('appThankYou/getHasCreditApplication', async () => {
  const response = await olaService.getOfferOlaCC()
  console.log('response >>>', response.data)
  return response.data
})

export const acceptOfferOlaCC = createAsyncThunk('appThankYou/acceptOfferOlaCC', async (_, { rejectWithValue }) => {
  try {
    const response = await olaService.acceptOfferOlaCC()
    console.log('response >>>', response)
    return response?.data
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const completeCCMonthlyIncome = createAsyncThunk('appThankYou/completeCCMonthlyIncome', async () => {
  const response = await ccService.completeCCMonthlyIncome()
  return response?.data
})

export const completeCCMonthlyExpenses = createAsyncThunk('appThankYou/completeCCMonthlyExpenses', async () => {
  const response = await ccService.completeCCMonthlyExpenses()
  return response?.data
})

export const completeCCProfOfIncome = createAsyncThunk('appThankYou/completeCCProfOfIncome', async () => {
  const response = await ccService.completeCCProfOfIncome()
  return response?.data
})

const initialState = {
  pending: false, // TODO set to true
  creditApplicationData: {
    type: "", // '',
    title: "", // '',
    description: ""
  }
}
export const appThankYouSlice = createSlice({
  name: 'appThankYou',
  initialState,
  extraReducers: {
    [getOfferOlaCC.fulfilled]: (state, action) => {
      state.creditApplicationData = action.payload || null
      state.pending = false
    },
    [getOfferOlaCC.pending]: (state) => {
      state.pending = true
    },
    [getOfferOlaCC.rejected]: (state) => {
      state.pending = false
      state.creditApplicationData = null
    }
  }
})

export default appThankYouSlice.reducer
